import { useAtom } from "jotai";
import { atomWithStorage, useAtomValue } from "jotai/utils";

import * as flowConfig from "flows/network-failure-analysis/config";

const PREFIX = `${flowConfig.FLOW_NAME}/create`;

const perfFile = atomWithStorage<string>(`${PREFIX}/performance-file`, null);

export const usePerfFile = () => useAtom(perfFile);

export const useGetPerfFile = () => useAtomValue(perfFile);

const timeColumn = atomWithStorage<string>(`${PREFIX}/time-column`, null);

export const useTimeColumn = () => useAtom(timeColumn);

export const useGetTimeColumn = () => useAtomValue(timeColumn);

const perfCellColumn = atomWithStorage<string>(
  `${PREFIX}/perf-cell-column`,
  null
);

export const usePerfCellColumn = () => useAtom(perfCellColumn);

export const useGetPerfCellColumn = () => useAtomValue(perfCellColumn);

const siteFile = atomWithStorage<string>(`${PREFIX}/site-file`, null);

export const useSiteFile = () => useAtom(siteFile);

export const useGetSiteFile = () => useAtomValue(siteFile);

const siteCellColumn = atomWithStorage<string>(
  `${PREFIX}/site-cell-column`,
  null
);

export const useSiteCellColumn = () => useAtom(siteCellColumn);

export const useGetSiteCellColumn = () => useAtomValue(siteCellColumn);

const siteLatColumn = atomWithStorage<string>(
  `${PREFIX}/site-lat-column`,
  null
);

export const useSiteLatColumn = () => useAtom(siteLatColumn);

export const useGetSiteLatColumn = () => useAtomValue(siteLatColumn);

const siteLongColumn = atomWithStorage<string>(
  `${PREFIX}/site-long-column`,
  null
);

export const useSiteLongColumn = () => useAtom(siteLongColumn);

export const useGetSiteLongColumn = () => useAtomValue(siteLongColumn);
